import { slideRight } from 'components/TruckerListItem/styled.animation';
import { DESKTOP_BREAKPOINT_WIDTH_HEADER } from 'constants/styled.contants';
import styled, { css } from 'styled-components';

export const UpdateWrapper = styled.div<{ $showPurchaseExtraTruckersButton?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing.km2};
  width: 100%;

  @media (min-width: ${({ theme }) =>
      theme.breakpoint.md.maxWidth}) and (max-width: ${DESKTOP_BREAKPOINT_WIDTH_HEADER}) {
    ${({ $showPurchaseExtraTruckersButton }) =>
      $showPurchaseExtraTruckersButton &&
      css`
        position: relative;
        top: 12px;
        left: 190px;
        min-width: 100%;
      `};
  }

  @container (width < 140px) {
    fuel-typography {
      display: none;
    }
  }
`;

export const ContentResultAndUpdate = styled.div<{ hasTarrifTab: boolean; $showPurchaseExtraTruckersButton?: boolean }>`
  ${({ theme, $showPurchaseExtraTruckersButton }) => css`
    display: flex;
    align-items: flex-start;
    position: absolute;
    right: 0;
    bottom: -28px;
    gap: ${theme.spacing.km8};
    @media (max-width: ${theme.breakpoint.sm.maxWidth}) {
      ${!$showPurchaseExtraTruckersButton &&
      css`
        display: none;
      `};
    }
    ${$showPurchaseExtraTruckersButton &&
    css`
      align-items: center;
    `};

    span {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: ${theme.spacing.km3};
      width: 100%;
    }

    fuel-tooltip {
      margin-bottom: -4px;
      cursor: pointer;
    }

    @media (max-width: ${theme.breakpoint.md.minWidth}) {
      width: 100%;
      justify-content: flex-end;
    }
  `}
`;

export const Sidebar = styled.div<{ animation: 'none' | 'left' | 'right' }>`
  width: 100%;
  height: 100%;
  overflow-x: auto;
  padding-right: ${({ theme }) => theme.spacing.km4};
  position: relative;

  &::-webkit-scrollbar-track {
    background-color: unset;
  }

  ${({ animation }) =>
    animation === 'left' &&
    css`
      ul {
        animation: ${slideRight} 0.6s cubic-bezier(0.32, 0, 1, -0.1) 0.2s forwards;
      }
    `};

  > fuel-tab {
    padding-top: ${({ theme }) => theme.spacing.km4};
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.km4};

  padding-top: ${({ theme }) => theme.spacing.km10};
  padding-bottom: ${({ theme }) => theme.spacing.km2};
  transition: opacity 0.15s linear;
  opacity: 1;
  z-index: 12;
  position: relative;

  @media (max-width: ${({ theme }) => theme.breakpoint.md.maxWidth}) {
    padding: ${({ theme }) => theme.spacing.km6};
  }
`;

export const FiltersWrapper = styled.div<{ $showPurchaseExtraTruckersButton?: boolean }>`
  width: 100%;
  background: ${({ theme }) => theme.color.background.neutral.default};
  padding-top: ${({ theme }) => theme.spacing.km6};
  position: relative;
  z-index: 11;
  transition: all 0.2s cubic-bezier(0.65, 0, 0.35, 1);
  opacity: 1;

  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.km2};
  align-items: flex-start;

  @media (min-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    ${({ $showPurchaseExtraTruckersButton }) =>
      $showPurchaseExtraTruckersButton &&
      css`
        align-items: center;
      `}
  }

  @media (min-width: ${({ theme }) =>
      theme.breakpoint.md.maxWidth}) and (max-width: ${DESKTOP_BREAKPOINT_WIDTH_HEADER}) {
    ${({ theme, $showPurchaseExtraTruckersButton }) =>
      $showPurchaseExtraTruckersButton &&
      css`
        gap: ${theme.spacing.km4};
        align-items: flex-start;
      `}
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.md.maxWidth}) {
    padding: ${({ theme }) => theme.spacing.km2};
    width: unset;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.km2};
  }
`;

export const WrapperToast = styled.div`
  & fuel-toast:first-child {
    left: ${({ theme }) => theme.spacing.km12};
    bottom: 210px;

    @media screen and (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
      left: 0;
    }
  }

  fuel-toast {
    position: fixed;
    left: ${({ theme }) => theme.spacing.km12};
    bottom: ${({ theme }) => theme.spacing.km12};

    @media screen and (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
      left: 0;
      bottom: 0;
      padding: ${({ theme }) => theme.spacing.km4};
    }
  }
`;

export const CheckboxOptionsWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const ExtraButtonsWrapper = styled.div`
  align-self: flex-end;
  max-width: 360px;
  width: 100%;
  gap: ${({ theme }) => theme.spacing.km2};
  flex-direction: column;
  justify-content: flex-end;
  display: flex;
  align-items: flex-end;
`;
